import type { ReactNode } from 'react'
import SurveySidebar from '@/layouts/SurveySidebar'
import FlashMessages from '@/components/FlashMessages'
import ImpersonationBanner from '@/components/ImpersonationBanner'

interface SurveyLayoutProps {
  children: ReactNode
  survey: {
    id: number
    name: string
    status: 'draft' | 'active' | 'closed'
  }
}

export default function SurveyLayout({ children, survey }: SurveyLayoutProps) {
  return (
    <div className="flex h-screen bg-base-200">
      <SurveySidebar survey={survey} />

      <div className="flex min-w-0 grow flex-col overflow-auto">
        <ImpersonationBanner />
        {/* Mobile toggle bar */}
        <div className="sticky top-0 z-30 flex items-center h-16 px-4 bg-base-100 border-b border-base-200 lg:hidden">
          <label htmlFor="survey-sidebar-toggle" className="btn btn-square btn-ghost btn-sm">
            <span className="iconify lucide--menu size-5" />
          </label>
          <div className="flex-1 px-2 font-bold flex items-center gap-2">
            <img src="/logo.svg" alt="" className="size-6" />
            ImpactCheck
          </div>
        </div>

        {/* Page content */}
        <main className="grow pt-6 px-6 pb-6">
          <FlashMessages />
          {children}
        </main>

        {/* Footer */}
        <footer className="px-6 py-3 text-center">
          <p className="text-xs text-base-content/40">
            Powered by{' '}
            <a
              href="https://www.envisialearning.com"
              target="_blank"
              rel="noopener noreferrer"
              className="link link-hover"
            >
              Envisia
            </a>
          </p>
        </footer>
      </div>
    </div>
  )
}
